/* eslint react-hooks/exhaustive-deps: "warn" */

import { useContext } from 'react';

import { ContentContext } from 'context/ContentContext';

import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { Faq } from 'ui/atoms/Faq/Faq';
import { HeroSection } from 'ui/molecules/HeroSection/HeroSection';
import { OurCustomersV2 } from 'ui/molecules/OurCustomers/OurCustomersV2';
import { DeliveryTable } from 'ui/organisms/DeliveryTable/DeliveryTable';

import styles from './TaxIdVatValidationPage.module.scss';

import { AuthorityBand } from './sections/AuthorityBand/AuthorityBand';
import { CoverageSection } from './sections/CoverageSection/CoverageSection';
import { HowItWorksSection } from './sections/HowItWorksSection/HowItWorksSection';
import { InPracticeSection } from './sections/InPracticeSection/InPracticeSection';
import { MonitoringSection } from './sections/MonitoringSection/MonitoringSection';
import { ViesComparisonSection } from './sections/ViesComparisonSection/ViesComparisonSection';
import { TaxIdValidationHeroCard } from './sections/TaxIdValidationHeroCard/TaxIdValidationHeroCard';
import { getDeliveryRows, getFaqData } from './TaxIdVatValidationPage.data';

export const TaxIdVatValidationPage = () => {
  const { secondaryNavigation } = useContext(ContentContext);
  const { t } = useInt();

  return (
    <div className={styles.wrapper}>
      <HeroSection
        align="left"
        mediaPosition="right"
        title={t('Validate any VAT or EIN number. Identify the company.')}
        description={
          <>
            {t(
              "We check EIN and VAT numbers against the issuing tax authority, then resolve the number to the legal entity in that country's company register — and keep a timestamped record of both.",
            )}
          </>
        }
        actions={
          <>
            {secondaryNavigation?.book_demo?.slug && (
              <Button type="dark-outline" size="xxl" route={secondaryNavigation.book_demo.slug}>
                {t('Get a quote')}
              </Button>
            )}

            {secondaryNavigation?.free_trial?.slug && (
              <Button type="dark" size="xxl" route={secondaryNavigation.free_trial.slug}>
                {t('Request a demo')}
              </Button>
            )}
          </>
        }
        media={<TaxIdValidationHeroCard />}
      />

      <AuthorityBand />

      <OurCustomersV2 hasBackground={false} />

      <HowItWorksSection />

      <CoverageSection />

      <MonitoringSection />

      <ViesComparisonSection />

      <DeliveryTable
        title={t('Delivered the way your team works')}
        description={t(
          'Start in the platform today, integrate when volume demands it. The underlying record never changes.',
        )}
        rows={getDeliveryRows(t)}
      />

      <InPracticeSection />

      <Faq title={t('Straight answers')} data={getFaqData(t)} />
    </div>
  );
};
